import { Store, Dispatch } from '../State';
import { getJson, RESOLVE_DYNAMIC_DATA_HEADER } from '../server';
import { setPhrases } from '../Translate';
import { AppShellData } from './index';
import { appShellDataUrl } from './utils';
import * as crossWindowEvents from '../cross-window-events';
import { dispatchScopeEvent as scopeEventDispatch } from '../events';
import { resolveComponentAndChildComponents } from '../resolve-component';
import { Action } from 'redux';

export const UPDATE_APP_SHELL_DATA = 'UPDATE_APP_SHELL_DATA';

export type UpdateAppShellDataAction<TAppShell = AppShellData> = Action & {
  appShellData: TAppShell;
};

export function updateAppShellData(isCurrentBrowserTab: boolean = true, resolveDynamicData = true) {
  if (isCurrentBrowserTab) {
    crossWindowEvents.emitCrossWindow('update-appshelldata');
  }
  return async (dispatch: Dispatch) => {
    const headers = resolveDynamicData ? { [RESOLVE_DYNAMIC_DATA_HEADER]: 'true' } : undefined;
    const appShellData = await getJson(appShellDataUrl, headers);
    setPhrases(appShellData.languagePhrases);
    await resolveComponentAndChildComponents(appShellData, appShellData.currentTheme);
    const updateAppShellDataAction: UpdateAppShellDataAction<{}> = {
      type: UPDATE_APP_SHELL_DATA,
      appShellData,
    };
    scopeEventDispatch(updateAppShellDataAction);
    dispatch(updateAppShellDataAction);
  };
}

export function initUpdateAppShellDataOnSchedule(store: Store, automaticReloadInSeconds = 5 * 60) {
  let updateOnNextVisible = false;

  setInterval(() => {
    if (!document.hidden) {
      store.dispatch(updateAppShellData());
    } else {
      updateOnNextVisible = true;
    }
  }, automaticReloadInSeconds * 1000);

  document.addEventListener(
    'visibilitychange',
    () => {
      if (updateOnNextVisible && !document.hidden) {
        store.dispatch(updateAppShellData());
        updateOnNextVisible = false;
      }
    },
    false,
  );
}

crossWindowEvents.onCrossWindow('update-appshelldata', store => {
  store.dispatch(updateAppShellData(false));
});
